// extracted by mini-css-extract-plugin
module.exports = {"sectionN":"SectionN_sectionN__utYPM"};